'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CountryService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _countryCodes = require('./countryCodes');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Provides a list of countries. By default, Finland is on the top of the list.
//
// Contains an array (countries) of 
// 
// { 
//   'Code': 'FI',
//   'Name': 'Suomi',
// },
//
// Name being translated according to the current locale.
//
// Sorted by name, but Finland being first.
var CountryService = exports.CountryService = function () {
    function CountryService($filter, $rootScope) {
        var _this = this;

        _classCallCheck(this, CountryService);

        this.$filter = $filter;

        this.rebuildCountries();
        $rootScope.$on('i18nextLanguageChange', function () {
            _this.rebuildCountries();
        });
    }

    _createClass(CountryService, [{
        key: 'rebuildCountries',
        value: function rebuildCountries() {
            // Country order
            // remove spaces and split by ,
            var order = this.order && this.order.length > 0 ? this.order.replace(' ', '').split(',') : [];

            // All country / ETA country
            var codes = this.eta ? _countryCodes.countryCodesETA : _countryCodes.countryCodes;

            // Sort so that Finland is first.
            //if (!_.some(order, o => o === 'FI')) {
            if (order.length === 0) {
                order.push('FI');
            }

            var i18next = this.$filter('i18next');
            this.countries = _.sortBy(_.map(codes, function (code) {
                return {
                    Code: code,
                    Name: i18next('country.' + code) || code
                };
            }), function (country) {
                var findIndex = _.findIndex(order, function (o) {
                    return country.Code === o;
                });
                return findIndex != -1 ? findIndex + country.Name : order.length + country.Name;
            });
        }
    }]);

    return CountryService;
}();

CountryService.$inject = ['$filter', '$rootScope'];


//////////////////
// WEBPACK FOOTER
// ./src/core/countryService.js
// module id = 74
// module chunks = 0 2